/*
  Vista previa de los megamenús.

  Al pasar el cursor por un enlace que trae data-eq-preview-src, la columna de
  la derecha del panel cambia su contenido por la foto de esa colección. Al
  salir del panel vuelve a lo de siempre.

  La imagen se precarga antes de mostrarla para que no se vea el hueco en
  blanco mientras descarga, y un pequeño retardo evita que la columna
  parpadee si el cursor sólo pasa de largo por encima de la lista.
*/
(function () {
  'use strict';

  var RETARDO = 90; // ms antes de mostrar, para no reaccionar al paso rápido

  function conecta(panel) {
    if (panel.dataset.eqPreviewReady === 'true') return;

    var slot = panel.querySelector('[data-eq-preview-slot]');
    if (!slot) return;

    var defecto = panel.querySelectorAll('[data-eq-preview-default]');
    var img = slot.querySelector('[data-eq-preview-img]');
    var titulo = slot.querySelector('[data-eq-preview-title]');
    var sub = slot.querySelector('[data-eq-preview-sub]');
    var enlaces = panel.querySelectorAll('[data-eq-preview-src]');
    if (!enlaces.length) return;

    panel.dataset.eqPreviewReady = 'true';

    var temporizador = null;
    var actual = null;

    function oculta() {
      window.clearTimeout(temporizador);
      actual = null;
      slot.hidden = true;
      for (var i = 0; i < defecto.length; i++) defecto[i].hidden = false;
    }

    function muestra(enlace) {
      var src = enlace.getAttribute('data-eq-preview-src');
      if (!src || src === actual) return;

      var previa = new Image();
      previa.onload = function () {
        // Puede haber cambiado de enlace mientras descargaba.
        if (enlace.getAttribute('data-eq-preview-src') !== src) return;
        actual = src;
        img.src = src;
        img.alt = enlace.getAttribute('data-eq-preview-name') || '';
        if (titulo) titulo.textContent = enlace.getAttribute('data-eq-preview-name') || '';
        if (sub) sub.textContent = enlace.getAttribute('data-eq-preview-note') || '';
        for (var i = 0; i < defecto.length; i++) defecto[i].hidden = true;
        slot.hidden = false;
      };
      previa.src = src;
    }

    for (var i = 0; i < enlaces.length; i++) {
      (function (enlace) {
        enlace.addEventListener('mouseenter', function () {
          window.clearTimeout(temporizador);
          temporizador = window.setTimeout(function () { muestra(enlace); }, RETARDO);
        });
        // Con teclado también: al tabular por la lista se ve la misma previa.
        enlace.addEventListener('focus', function () { muestra(enlace); });
      })(enlaces[i]);
    }

    panel.addEventListener('mouseleave', oculta);
  }

  function arranca() {
    document.querySelectorAll('.eq-mm').forEach(conecta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }

  document.addEventListener('shopify:section:load', arranca);
})();
